import { useEffect, useState } from "react";
import { useAPIGetDashboard } from "../api/api-get-dashboard";
import OwnerDashboardGlobalFilter from "./OwnerDashboardGlobalFilter";
import OwnerDashboardNavbar from "./OwnerDashboardNavbar";
import OwnerDashboardGeneralPage from "./OwnerDashboardGeneralPage/OwnerDashboardGeneralPage";
import OwnerDashboardCustomerPage from "./OwnerDashboardCustomerPage/OwnerDashboardCustomerPage";
import { AnimatePresence, motion } from "framer-motion";
import OwnerDashboardEmployeePage from "./OwnerDashboardEmployeePage/OwnerDashboardEmployeePage";

const OwnerDashboardMain = () => {
  const {
    loading,
    error,
    fetchGeneralData,
    fetchEmployeeData,
    fetchCustomerData,
    setFilterValue,
    filterValue,
    generalData,
    employeeData,
    customerData,
  } = useAPIGetDashboard();

  const [isExpanded, setIsExpanded] = useState(false);
  const [activeMenu, setActiveMenu] = useState("general");

  useEffect(() => {
    if (activeMenu === "general") {
      fetchGeneralData({});
    }
    if (activeMenu === "employee") {
      fetchEmployeeData({});
    }
    if (activeMenu === "customer") {
      fetchCustomerData({});
    }
  }, [filterValue, activeMenu]);

  return (
    <div className="w-full p-4 gap-4 col-start-start">
      <OwnerDashboardGlobalFilter
        setFilterValue={setFilterValue}
        filterValue={filterValue}
        error={error}
        loading={loading}
      />

      <OwnerDashboardNavbar
        isExpanded={isExpanded}
        activeMenu={activeMenu}
        setIsExpanded={setIsExpanded}
        setActiveMenu={setActiveMenu}
      />

      <AnimatePresence mode="wait">
        <motion.div
          key={activeMenu}
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 50 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="col-center-start w-full gap-2"
        >
          {activeMenu === "general" && (
            <OwnerDashboardGeneralPage
              data={generalData}
              filterValue={filterValue}
              loading={loading}
            />
          )}

          {activeMenu === "customer" && (
            <OwnerDashboardCustomerPage
              data={customerData}
              filterValue={filterValue}
              loading={loading}
            />
          )}

          {activeMenu === "employee" && (
            <OwnerDashboardEmployeePage
              data={employeeData}
              filterValue={filterValue}
              loading={loading}
            />
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default OwnerDashboardMain;
